import Koa from 'koa'

export function initMiddlewares(_app: Koa) {
  /* can add middlewares into app */
}
